import { Listbox } from '@headlessui/react';
import { ChevronUpDownIcon, CheckIcon } from '@heroicons/react/20/solid';
import { useRefinementList } from 'react-instantsearch';

export function FacetDropdown({ attribute, placeholder = 'Select...', title = ''}) {
    const { items, refine } = useRefinementList({ attribute });
    const selectedItems = items.filter(item => item.isRefined);

    const handleChange = (selected) => {
        refine(selected.value);
    };

    return (
        <Listbox value={selectedItems} onChange={handleChange}>
            {({ open }) => (
                <div className="relative bg-gray-50 p-5 rounded-lg">
                    <fieldset>
                        <legend className="block text-sm mb-4 font-medium text-gray-900">
                            {title}
                        </legend>
                    </fieldset>

                    <Listbox.Button className="relative w-full cursor-default rounded-md bg-white py-2 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-sky-600 sm:text-sm sm:leading-6">
                        <span className="block truncate">
                            {selectedItems.length === 0 ? placeholder : `${selectedItems.length} valgt`}
                        </span>
                        <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                            <ChevronUpDownIcon className="h-5 w-5 text-gray-400"/>
                        </span>
                    </Listbox.Button>

                    <Listbox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                        {items.map((item) => (
                            <Listbox.Option
                                key={item.value}
                                value={item}
                                className={({ active }) =>
                                    `relative cursor-default select-none py-2 pl-3 pr-9 text-left
                                    ${active ? 'bg-sky-600 text-white' : 'text-gray-900'}`
                                }
                            >
                                {({ selected, active }) => (
                                    <>
                                        <span className={`block truncate ${item.isRefined ? 'font-semibold' : 'font-normal'}`}>
                                            {item.label} ({item.count})
                                        </span>
                                        {item.isRefined && (
                                            <span className={`absolute inset-y-0 right-0 flex items-center pr-4
                                                ${active ? 'text-white' : 'text-sky-600'}`}
                                            >
                                                <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                            </span>
                                        )}
                                    </>
                                )}
                            </Listbox.Option>
                        ))}
                    </Listbox.Options>
                </div>
            )}
        </Listbox>
    );
}